<template>
    <v-container>
        <v-form>
            <v-text-field v-model="title" autofocus label="Judul"></v-text-field>

            <v-textarea v-model="content" label="Konten"></v-textarea>

            <div class="text-right">
                <v-btn @click="save" rounded color="primary" :loading="$store.get('loader/loading', 'saving')">Simpan</v-btn>
            </div>
        </v-form>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            title: null,
            content: null,
        }
    },

    methods: {
        save() {
            this.$api.put(`help/${this.$route.params.help_id}`, {
                title: this.title,
                content: this.content
            })
                .then(response => {
                    if (response.data.updated) {
                        this.$store.dispatch('flash/info', 'Bantuan telah diedit')
                        this.$router.replace({ name: 'help.manage' })
                    } else {
                        this.$store.dispatch('flash/genericError')
                    }
                })
        }
    },

    created() {
        this.$api.get(`help/${this.$route.params.help_id}`)
            .then(response => {
                this.title = response.data.title
                this.content = response.data.content
            })
    }
}
</script>
